import { useState, useEffect } from "react";
import { logo } from "./../assets/images/images";
import { Link, useLocation } from "react-router-dom";
import Icon from "./Icon";
import UserProfileMenu from "./UserProfileMenu/UserProfileMenu";
import Backdrop from "./Backdrop";
import Modal from "./Modal";
import OfferOverlay from "./OfferOverlay/OfferOverlay";
import { useSelector } from "react-redux";
import { isAdmin } from "../utils/checkAdmin";

function Navbar() {
  const state = useSelector((state) => state);
  const [loggedIn, setLoggedIn] = useState(false);
  const [showOffer, setShowOffer] = useState(false);
  const location = useLocation();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (state.user.auth) {
      setLoggedIn(true);
    } else {
      setLoggedIn(false);
    }
  });

  const hideOfferModal = () => {
    setShowOffer(false);
  };
  return (
    <div className="p-[1.5rem] pt-2 bg-bgMain flex gap-8 items-start justify-between">
      {/* LOGO */}
      <div>
        <img src={logo} className="block h-[4rem] " alt="logo" />
      </div>
      {/* NAV ITEMS */}
      <div className="sm:hidden font-Ropa font-[400] text-xl mr-auto self-center md:flex text-[#707070]  hidden  justify-between mt-3  gap-10">
        <Link
          to="/"
          className={
            location.pathname !== "/"
              ? "hover:opacity-80 transition ease-out"
              : "hover:opacity-80 transition ease-out border-b-4 rounded-b-[4px] border-greyPrimary "
          }
        >
          Home
        </Link>
        <Link
          to="/menu"
          className={
            location.pathname !== "/menu"
              ? "hover:opacity-80 transition ease-out"
              : "hover:opacity-80 transition ease-out border-b-4 rounded-b-[4px] border-greyPrimary "
          }
        >
          Menu
        </Link>
        {/* <Link
          className=' flex gap-1 hover:opacity-80 transition ease-out'
          to='/'
        >
          <span>BRANCHES</span>
          <Icon name='arrowDown' className='w-2 h-2 mt-[0.5rem]' />
        </Link> */}
        {/* <button
          onClick={() => setShowOffer(true)}
          className=' hover:opacity-80 transition ease-out flex gap-1 '
        >
          <span>OFFERS</span>
        </button> */}
        <Link
          to="/contact"
          className={
            location.pathname !== "/contact"
              ? "hover:opacity-80 transition ease-out flex gap-1"
              : "hover:opacity-80 transition ease-out  flex gap-1 border-b-4 rounded-b-[4px] border-greyPrimary "
          }
        >
          <span>Contact Us</span>
        </Link>
        {state.user && isAdmin(state.user?.role) && (
          <Link to="admin" className="hover:opacity-80 transition ease-out">
            ADMIN
          </Link>
        )}
      </div>
      {/* NAV SEARCH */}
      {/* <NavSearch /> */}
      {/* HELP */}
      {loggedIn ? (
        <LoggedInUi user={state.user} />
      ) : (
        <div className="flex self-center gap-4 text-greyPrimary items-center">
          {/* <Link to='/signup'>
            <button className='border p-2 rounded-lg'>Sign Up</button>
          </Link> */}
          <Link to="/login">
            <button className=" text-xl font-Ropa hover:opacity-80 transition ease-out p-2 text-[#707070] rounded-lg">
              Login
            </button>
          </Link>
          <Link to="/cart" className="relative">
            <Icon
              name="newCart"
              className="w-8 h-8 hover:opacity-80 transition ease-out "
            />

            <div className="absolute rounded-full w-6 h-6 flex items-center justify-center bg-red-500 text-white right-[-1rem] top-[-.5rem]">
              {state.cart.cartItems.length}
            </div>
          </Link>
        </div>
      )}

      {/* OFFER MODAL */}
      <Modal show={showOffer} close={hideOfferModal}>
        {showOffer && <OfferOverlay />}
      </Modal>
    </div>
  );
}

function LoggedInUi(props) {
  const state = useSelector((state) => state.cart);
  const [showUserMenu, setShowUserMenu] = useState(false);
  if (!props.user) return <></>;
  return (
    <div className="flex gap-4 self-center items-center">
      <div className="relative">
        <button
          onClick={() => setShowUserMenu((prev) => !prev)}
          className="text-white text-sm capitalize hover:opacity-80 transition ease-out p-2 bg-greySecondary rounded-lg font-bold"
        >
          {props.user.firstname} {props.user.lastname}
        </button>
        {/* USER MENU */}
        {showUserMenu && (
          <>
            <div className="absolute z-40 drop-shadow-2xl right-0 top-[140%]  rounded-lg  w-max bg-white">
              <UserProfileMenu />
              {/* TOP ARROW */}
              <span className="block  absolute top-[-12px] right-12">
                <Icon name="triangle" className="w-4 h-4 fill-white" />
              </span>
            </div>
            <Backdrop
              show={showUserMenu}
              onClick={() => setShowUserMenu(false)}
              style={{ background: "transparent" }}
            />
          </>
        )}
      </div>

      <Link to="/cart">
        <Icon
          name="newCart"
          className="w-10 h-10 hover:opacity-80 transition ease-out"
        />
        <div className="absolute rounded-full w-6 h-6 flex items-center justify-center bg-red-500 text-white right-[.5rem] top-[.5rem]">
          {state.cartItems.length}
        </div>
      </Link>
    </div>
  );
}

export default Navbar;
